module.exports = "<form class=\"form\" name=\"ReviewForm\" ng-submit=\"leaveReview()\">\n  <br>\n  <h4>Leave a review</h4>\n  <br>\n  <div class=\"form-group\">\n    <select class=\"form-control\" name=\"rate\" ng-model=\"review.rate\" ng-options=\"rate for rate in rates\"></select>\n  </div>\n  <div class=\"form-group\">\n    <textarea class=\"form-control\" name=\"content\" ng-model=\"review.content\"></textarea>\n  </div>\n\n  <button class=\"form-control\">Send</button>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/review_form.html
// module id = 495
// module chunks = 24